module.exports = __webpack_public_path__ + "eb8d607aa245998008a6defbbc93485b.svg";